import { composeIBAN } from 'ibantools';

type QRPayment = {
  countryCode: string;
  bankAccount: string | undefined;
  variableSymbol: string | undefined;
  amount: number | undefined;
  currency: string;
};

// Builds a Czech SPD*1.0 QR payment string; prefix is zero-padded to 6 digits per the standard
export const composeQRPayment = (data: QRPayment): string => {
  const prefix = String(
    data.bankAccount?.substring(0, data.bankAccount.indexOf('-')) || '',
  ).padStart(6, '0');
  const account = String(
    data.bankAccount?.substring(
      data.bankAccount.indexOf('-') + 1,
      data.bankAccount.indexOf('/'),
    ) || '',
  ).padStart(10, '0');
  const code = data.bankAccount?.slice(-4) || '0000';

  return String().concat(
    'SPD*1.0',
    '*ACC:',
    composeIBAN({
      countryCode: data.countryCode,
      bban: code + prefix + account,
    })!,
    '*AM:',
    String(data.amount),
    '*CC:',
    data.currency,
    '*X-VS:',
    String(data.variableSymbol),
  );
};
// Masks an IBAN-format account number, exposing only the first 4 and last 4 characters
export default function bankAccountFormat(bankAccount: string) {
  const endOfNumber = bankAccount.slice(20, 24);
  const startOfNumber = bankAccount.slice(0, 4);
  const printedBankNumber = `${startOfNumber}-****-****-**-******${endOfNumber}`;

  return printedBankNumber;
}
